(function ($) {
	$(function () {
		$('ul.site-categories a')
			.each(function (index, e) {
				var $e = $(e);
				var country = $e.parent().data('region');
				var qs = $.deparam.querystring();
				if ($.cookie('selected_country') === country)
				{
					$('#chk-enable-cookie').prop('checked', true);
					if (typeof qs.loc != 'undefined' && qs.force !== '1') {
						location.replace($e.attr('href'));
						return;
					}
				}

				$e
				.data('region', country)
				.click(function() {
					var $t = $(this);

					var expires = new Date();
					expires.setFullYear( expires.getFullYear() + 1 );

					if ($('#chk-enable-cookie').prop('checked')) {
						$.cookie('selected_country', $t.data('region'), { domain: '.ti.com', path: '/', expires: expires });
					} else {
						$.cookie('selected_country', null, { domain: '.ti.com', path: '/', expires: expires });
					}
				});
			});
	});
})(jQuery);
